import React from 'react';
import { ApiClient } from './api-client';

export const ApiClientContext = React.createContext<ApiClient>(new ApiClient());
